import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const StartPage = lazy(() => import('../pages/start/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SurveyPage = lazy(() => import('../pages/survey/page'));
const SuccessPage = lazy(() => import('../pages/success/page'));
const PlanPage = lazy(() => import('../pages/plan/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <StartPage />,
  },
  {
    path: '/home',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/survey',
    element: <SurveyPage />,
  },
  {
    path: '/success',
    element: <SuccessPage />,
  },
  {
    path: '/plan',
    element: <PlanPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
